import { Box } from "@mui/material";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";

const FocusAreas = () => {
  const translate = useTranslate();

  const [isSeeAll, setIsSeeAll] = useState<boolean>(false);
  const [focusedItems, setFocusedItems] = useState<string[] | []>([]);

  const selectedFocusAreas: string[] = useAppSelector((state) => state.suggestedPlans.selectedFocusAreas);

  useEffect(() => {
    const subset = selectedFocusAreas?.slice(0, 6);
    if (!isSeeAll) {
      setFocusedItems(subset);
    } else {
      setFocusedItems(selectedFocusAreas);
    }
  }, [isSeeAll, selectedFocusAreas]);

  const handleSetSeeAll = () => {
    setIsSeeAll(!isSeeAll);
  };

  return (
    <Box className="no-plan-banner-suggested-container" marginTop={"8px"}>
      <div className="inner-wrapper">
        {focusedItems.map((data, i: number) => {
          return (
            <>
              {i === 0 && (
                <Typography variant="body2" color={tokens.Icon.General.Inverse} className="dots">
                  "
                </Typography>
              )}
              <Typography variant="body2" color={tokens.Icon.General.Inverse} key={`focues${data}`}>
                {data}
              </Typography>
              {focusedItems?.length - 1 !== i && (
                <Typography variant="body2" color={tokens.Icon.General.Inverse} className="ml-4">
                  /
                </Typography>
              )}
              {i === focusedItems?.length - 1 && (
                <Typography variant="body2" color={tokens.Icon.General.Inverse} className="dots">
                  "
                </Typography>
              )}
            </>
          );
        })}
        {selectedFocusAreas?.length > 6 && !isSeeAll && (
          <Typography variant="body2" showBold color={tokens.Icon.General.Inverse} className="dots">
            (...)
          </Typography>
        )}
        {!isSeeAll && selectedFocusAreas?.length > 6 && (
          <Typography
            variant="body2"
            showBold
            color={tokens.Icon.General.Inverse}
            className="see-more cursor-pointer"
            onClick={() => handleSetSeeAll()}
          >
            {translate("common.seeMore")}
          </Typography>
        )}
      </div>
      {isSeeAll && (
        <Typography
          variant="body2"
          color={tokens.Icon.General.Inverse}
          showBold
          className="see-less cursor-pointer"
          onClick={() => handleSetSeeAll()}
        >
          {translate("common.seeLessUpper")}
        </Typography>
      )}
    </Box>
  );
};

export default FocusAreas;
